import { Injectable, inject } from '@angular/core';

import { Types } from '../../types.domain';
import { ValidateCpfEmailServiceInterface } from '../interfaces/services/validate-cpf-email.service.interface';
import { ValidateCpfEmailInput } from '../dtos/validate-cpf-email.input';
import { ValidateCpfEmailOutput } from '../dtos/validate-cpf-email.output';

@Injectable()
export class ValidateCpfEmailService implements ValidateCpfEmailServiceInterface {
  private readonly _userRepository = inject(Types.UserRepository);

  async handle(input: ValidateCpfEmailInput): Promise<ValidateCpfEmailOutput> {
    return await this._userRepository.validateCpfEmail(input);
  }
}
